import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Badge from "UI/Badge";
import Well from "UI/Well";

export default class ProjectListSelect extends React.Component
{
    static propTypes = {
        projects: PropTypes.array.isRequired,
        selected: PropTypes.array
    };

    static defaultProps = {
        selected: []
    }

    render()
    {
        if ( this.props.projects.length < 1) {
            return <Well>You have no projects.</Well>;
        }

        return <div className='space-y-2'>
            {
                _.map(
                    this.props.projects,
                    project => <ProjectListSelectItem
                        key={project.id}
                        {...project}
                        selected={this.props.selected.includes(project.id)}
                        onChange={e => this.props.onChange(project.id, e.target.checked)}
                    />
                )
            }
        </div>;
    }
}

const ProjectListSelectItem = ({id, name, selected, colour, onChange}) => {
    const field = 'project_' + id;

    return <div className="flex items-center">

        <input
            id={field}
            type="checkbox"
            checked={selected}
            onChange={onChange}
            className="cursor-pointer focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
        />

        <label htmlFor={field} className="cursor-pointer w-full ml-2 block">
            <Badge colour={colour}>{ name }</Badge>
        </label>
    </div>;
};
